"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeTypes = exports.serviceTypes = exports.ALL = exports.POPULARITY = exports.IS_UPCOMING = exports.IS_PREMIUM = exports.AGE_IN_DAYS = exports.NAME = void 0;
exports.NAME = 'name';
exports.AGE_IN_DAYS = 'ageInDays';
exports.IS_PREMIUM = 'isPremium';
exports.IS_UPCOMING = 'isUpcoming';
exports.POPULARITY = 'popularity';
exports.ALL = 'All';
exports.serviceTypes = (_a = {},
    _a[exports.POPULARITY] = 'Popular',
    _a[exports.NAME] = 'Alphabetical',
    _a[exports.AGE_IN_DAYS] = 'Recently Added',
    _a[exports.IS_PREMIUM] = 'Premium',
    _a);
exports.nodeTypes = {
    FILTER: 'filter',
    WRITE: 'write',
    SEARCH_OR_WRITE: 'search_or_write',
    READ: 'read',
    SEARCH: 'search',
    HAS_READS: 'hasReads',
    HAS_WRITES: 'hasWrites',
    HAS_SEARCHES: 'hasSearches',
    HAS_FILTERS: 'hasFilters',
    HAS_SEARCH_OR_WRITE: 'hasSearchOrWrites',
};
